module.exports = __webpack_public_path__ + "static/media/red-yellow.cd9a6212.png";